import React from "react"
import { Route } from "react-router-dom"
import LoginView from "./views/auth/LoginView"

const routes = [<Route path="/login" component={LoginView} />]

export default routes
